import React, {useEffect, useState} from 'react';
import {getModuleContentByName} from "../../services/CourseRepository";
import {useNavigate, useParams} from "react-router-dom";
import {TopBarNavigationCourse} from "../../components/navigation/TopBarNavigationCourse";
import {TextSelectionPopup} from "../../components/TextSelectionPopup";
import {AIProvider} from "../../hooks/useAI";
import {AIPanel} from "../../components/AIPanel";
import {ChapterNavigationBar} from "../../components/navigation/ChapterNavigationBar";
import {useError} from "../../hooks/useError";
import {CoursePage} from "./CoursePage";
import {routes} from "../../utils/Routes";

export function Course() {
    const params = useParams();
    const [course, setCourse] = useState(null);
    const [toggleSidebar, setToggleSidebar] = useState(false);
    const [toggleAIPanel, setToggleAIPanel] = useState(false);
    const {setErrorMessage} = useError();
    const navigate = useNavigate();

    useEffect(() => {
        if (params.hasOwnProperty("courseName")) {
            getModuleContentByName(params.courseName, params.moduleName, params.chapterName, setErrorMessage).then(result => {
                window.scrollTo({top: 0, left: 0, behavior: "instant"});
                setCourse(result);
            }).catch(err => {
                console.log(err)
            });
        }

        const handleKeyDown = (event) => handleKeyboardNavigation(event);

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

    }, [params.courseName, params.moduleName, params.chapterName]);

    function handleKeyboardNavigation(event) {
        if(course == null || course.product == null) {
            return;
        }

        if (event.key === 'ArrowRight') {
            const link = routes.chapterPageAbs(course.product.name, course.product.courseCode, course.nextChapter.moduleName, course.nextChapter.chapterName, course.nextChapter.modulePage)
            navigate(link)
        } else if (event.key === 'ArrowLeft') {
            const link = routes.chapterPageAbs(course.product.name, course.product.courseCode, course.prevChapter.moduleName, course.prevChapter.chapterName, course.prevChapter.modulePage)
            navigate(link)
        }
    }

    if (course != null) {


        return (

                <AIProvider>
                    <div className={"bg-neutral-3 "} >

                        <div className={"row bg-white"}>
                            <div className={"col-3 p-0 bg-white border-end sticky-sidebar  " + (!toggleSidebar ? "d-none" : "")} >
                                <ChapterNavigationBar courseId={course.product.courseCode}
                                                      initSelectedModule={course.module}
                                                      preview={false}
                                />
                            </div>

                            <div className={"col-4  p-0 bg-white border-end  "+(!toggleAIPanel ? "d-none" : "")}>
                                <AIPanel initCoins={course.coins}/>
                            </div>

                            <div className={"col  bg-white"}>
                                <TopBarNavigationCourse crumbs={course.crumbs}
                                                        clickCallback={(index) => {
                                                            if(index === 0) {
                                                                setToggleAIPanel(false)
                                                                setToggleSidebar(!toggleSidebar)
                                                            } else if(index === 1) {
                                                                setToggleSidebar(false)
                                                                setToggleAIPanel(!toggleAIPanel);
                                                            }
                                                        }}
                                                        nextChapter={course.nextChapter} prevChapter={course.prevChapter}
                                                        courseName={course.product.courseCode}/>
                                <CoursePage chapter={course.chapter} togglePanelCallback={setToggleAIPanel} integratedAi={true}/>
                            </div>
                        </div>
                    </div>

                </AIProvider>


        );

    }

}
